import React from 'react';
import { Flex } from '@chakra-ui/react';
import PropType from 'prop-types';

function TabPanelFooter({ children }) {
  return (
    <Flex
      justify="flex-end"
      mb={5}
      px={5}
      width="100%"
    >
      { children}
    </Flex>
  );
}
TabPanelFooter.propTypes = {
  children: PropType.element
};

export default TabPanelFooter;
